import React, { useEffect, useRef, useState } from "react";
import exportPic from "../assets/images/export.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getSubAdminData,
  subAdminStatusChanged,
} from "../features/slices/subAdmin";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { toastService } from "../utils/toastify";
import CommonPagination from "../components/CommonPagination";
import ExportToExcel from "../components/ExportToExcel";
import { canPerformAction } from "../utils/denyAccess";
const initialState = {
  searchQuery: "",
};
const SubAdmin = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { searchQuery } = iState;
  const [page, setPage] = useState(1);
  const subAdminRef = useRef();
  const dispatch = useDispatch();
  const { subAdminData, loading } = useSelector((state) => state.subAdmin);

  useEffect(() => {
    dispatch(getSubAdminData({ page }));
    window.scrollTo(0, 0);
  }, [page]);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getSubAdminData({ page }));
  };
  const handleChangeStatus = (e, id) => {
    const status = e.target.checked ? "ACTIVE" : "INACTIVE";
    dispatch(
      subAdminStatusChanged({
        id: id,
        status: status,
      })
    ).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getSubAdminData({ page })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleSearch = (e) => {
    setUpdateState({ ...iState, searchQuery: e.target.value });
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getSubAdminData({ search: searchQuery?.trim() }));
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchQuery]);
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox justify-content-end">
          {canPerformAction("Sub-Admin") && (
            <Link to={"AddSubAdmin"} className="TitleLink">
              <i className="fa-solid fa-plus" /> Add Sub Admin
            </Link>
          )}
        </div>
        <div className="Small-Wrapper">
          <div className="NewFilter">
            <div className="SearchBox">
              <input
                type="search"
                className="SearchInput"
                placeholder="Search here by ID, Name, or Others"
                value={searchQuery}
                onChange={handleSearch}
              />
              <span>
                <i className="fa fa-search" />
              </span>
            </div>
            <div className="Actions">
              <button className="Button Cancel ml-2" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
              <ExportToExcel ref={subAdminRef} fileName="subAdminData" />
            </div>
          </div>
          <div className="TableList">
            <table className="table-hover" ref={subAdminRef}>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Sub-Admin Id</th>
                  <th>Sub-Admin Name</th>
                  <th>Number</th>
                  <th>Email Id</th>
                  <th>Registered Date</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subAdminData?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1}</td>
                      <td>{res?.subadmin_number}</td>
                      <td>
                        <div className="fw500"> {res?.name}</div>
                      </td>
                      <td>{res?.phoneNumber}</td>
                      <td>{res?.email}</td>
                      <td>{moment(res?.createdAt).format("DD/MM/YYYY")}</td>
                      <td>{res?.designation}</td>
                      <td>
                        <span
                          className={res?.status == "ACTIVE" ? "Green" : "Red"}
                        >
                          {res?.status}
                        </span>
                      </td>
                      <td>
                        <div className="Actions">
                          {canPerformAction("Sub-Admin") && (
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={res?.status !== "INACTIVE"}
                                onChange={(e) =>
                                  handleChangeStatus(e, res?._id)
                                }
                              />
                              <span className="slider" />
                            </label>
                          )}
                          <Link
                            to={"viewAubAdmin"}
                            className="Eyes"
                            state={res}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                          {canPerformAction("Sub-Admin") && (
                            <Link
                              to={"editSubAdmin"}
                              className="Edit"
                              state={res}
                            >
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                          )}
                          {/* <a class="Delete" href="javascript:void(0);" data-toggle="modal" data-target="#SubAdminDelete">
                                      <i class="fa-regular fa-trash-can"></i>
                                  </a> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {subAdminData?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {subAdminData?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {subAdminData?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    subAdminData?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubAdmin;
